export default __webpack_public_path__ + "static/lions-green-1805134b274f955264c91e2ba06a5856.png";